import { WarnIcon } from "./icons";
import InfoScreen from "./InfoScreen";
import { useI18n } from "../i18n";

type ErrorProps = {
  title?: string;
  message: string;
};

export default function Error(
  { title, message }: ErrorProps = { message: "" },
) {
  const { t } = useI18n();
  return (
    <InfoScreen
      icon={<WarnIcon className="w-12 h-12 text-error/80" />}
      title={title ?? t("error.title")}
    >
      <p className="opacity-70 mb-6">{message}</p>
      <button
        className="btn btn-primary"
        onClick={() => window.location.reload()}
      >
        {t("common.tryAgain")}
      </button>
    </InfoScreen>
  );
}
